import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { savedOrderDetailsActionButtonsStyles } from "@dana/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import MenuDefaultProps from "@insite/mobius/Menu/presentationProps";
import { css } from "styled-components";

savedOrderDetailsActionButtonsStyles.twoButtonModalStyles = mergeToNew(
    savedOrderDetailsActionButtonsStyles.twoButtonModalStyles,
    {
        css: css`
            background: ${themeBackgrounds.lightGray};
            padding: 16px;
            width: 100%;

            @media print {
                padding: 0 0 4px;
            }
        `,
    },
);

savedOrderDetailsActionButtonsStyles.narrowOverflowMenu = mergeToNew(
    savedOrderDetailsActionButtonsStyles.narrowOverflowMenu, {
       cssOverrides: {
            wrapper: css`
                margin-top: -4px;
            `
       },
    }
);